import React, { useState } from "react";
import { Box, Toolbar } from "@mui/material";
import { Sidebar, DRAWER_WIDTH, MINI_DRAWER_WIDTH } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";

const WIDTH_TRANSITION = "width 225ms cubic-bezier(0.4, 0, 0.2, 1), max-width 225ms cubic-bezier(0.4, 0, 0.2, 1)";

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    return localStorage.getItem("sidebar_collapsed") === "true";
  });

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleToggleCollapse = () => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem("sidebar_collapsed", String(next));
      return next;
    });
  };

  const effectiveWidth = collapsed ? MINI_DRAWER_WIDTH : DRAWER_WIDTH;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Header onMenuToggle={handleDrawerToggle} drawerWidth={effectiveWidth} />
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={handleToggleCollapse}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          width: { md: `calc(100% - ${effectiveWidth}px)` },
          maxWidth: { md: `calc(100% - ${effectiveWidth}px)` },
          transition: WIDTH_TRANSITION,
          bgcolor: "#f3f6f9",
          height: "100vh",
          overflow: "hidden",
          minWidth: 0,
        }}
      >
        <Toolbar /> {/* Spacer for fixed AppBar */}
        <Box sx={{ flex: 1, minHeight: 0, minWidth: 0, p: 2, overflowY: "auto", overflowX: "hidden" }}>{children}</Box>
        <Footer />
      </Box>
    </Box>
  );
}
